export default __webpack_public_path__ + "266cfd41405b7362881db0d18a244122.png";